import { render, staticRenderFns } from "./LabeledSection.vue?vue&type=template&id=31532f0a&scoped=true"
import script from "./LabeledSection.vue?vue&type=script&lang=js"
export * from "./LabeledSection.vue?vue&type=script&lang=js"
import style0 from "./LabeledSection.vue?vue&type=style&index=0&id=31532f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31532f0a",
  null
  
)

export default component.exports
import {QCard,QSpace,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QSpace,QBtn})
